export default __webpack_public_path__ + "static/media/Megosu - Made.com - 4.8d4f50f2.jpg";